/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Perm_Care_LogsInputs */

const vi_api_keys_perm_care_logs = /** @type {(inputs: Api_Keys_Perm_Care_LogsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhật ký chăm sóc`)
};

/**

* @param {Api_Keys_Perm_Care_LogsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_perm_care_logs = /** @type {((inputs?: Api_Keys_Perm_Care_LogsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Perm_Care_LogsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_perm_care_logs(inputs)
});